import { GuidedChangeType } from "src/routes/projects/change-events/guided/utils";
import { addOnBookOptionWorkflow } from "src/routes/projects/change-events/guided/workflows/addOnBookOption/addOnBookOptionWorkflow";
import { applyFullConfigurationWorkflow } from "src/routes/projects/change-events/guided/workflows/applyConfiguration/full/applyFullConfigurationWorkflow";
import { applyPartialConfigurationWorkflow } from "src/routes/projects/change-events/guided/workflows/applyConfiguration/partial/applyPartialConfigurationWorkflow";
import { GuidedWorkflow } from "src/routes/projects/change-events/guided/workflows/types";

// Maps a change type to the workflow that drives its steps. `GuidedWorkflow<any>`
// is the single, contained boundary where the per-workflow form shape is erased;
// each definition above keeps its concrete type, and the runner never inspects it.
export const guidedWorkflows: Record<GuidedChangeType, GuidedWorkflow<any>> = {
  [GuidedChangeType.ApplyFullConfiguration]: applyFullConfigurationWorkflow,
  [GuidedChangeType.ApplyPartialConfiguration]: applyPartialConfigurationWorkflow,
  [GuidedChangeType.AddOnBookOption]: addOnBookOptionWorkflow,
  // TODO: add the other workflows
  [GuidedChangeType.ConfigurationTrueUp]: null as any,
  [GuidedChangeType.SwapProductInCatalog]: null as any,
  [GuidedChangeType.SwapProductNotInCatalog]: null as any,
  [GuidedChangeType.FullLineCustomOption]: null as any,
};
